import React, { useEffect } from 'react';
import { useQuery } from 'react-query';

import { RadioChangeEvent } from 'antd';
import styled from 'styled-components';

import { getCompanyRentalTypeMetrics } from 'apis/CommunityAPI';
import Radio from 'components/lib/Radio';
import { useAppSelector } from 'store/hook';

import { VIEW_MODAL_ADD_COMMUNITY_TYPES } from '../../constants';

const CommunityTypesTitle = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
`;

const CommunityTypesContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 10px;
  font-size: 14px;
`;

const StyledRadio = styled(Radio)`
  font-size: 14px;
`;

interface Props {
  communityContractType?: number;
  setCommunityContractType: (val: number) => void;
}

const ViewInputModalCommunityRentalTypes = ({ communityContractType, setCommunityContractType }: Props) => {
  const { selectedCompany } = useAppSelector((state) => state.global);

  const { data, isLoading } = useQuery({
    queryKey: ['contractMetrics', selectedCompany],
    queryFn: () => getCompanyRentalTypeMetrics(),
    select: ({ rental_count, ccrc_count }) => ({
      rentalCommunitiesCount: rental_count,
      ccrcCommunitiesCount: ccrc_count,
    }),
    enabled: Boolean(selectedCompany),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (data?.ccrcCommunitiesCount === 0) {
      setCommunityContractType(VIEW_MODAL_ADD_COMMUNITY_TYPES.RENTAL);
    } else if (data?.rentalCommunitiesCount === 0) {
      setCommunityContractType(VIEW_MODAL_ADD_COMMUNITY_TYPES.CCRC);
    }
  }, [selectedCompany, data]);

  // Don't show the choice if there is only one type of community available
  if (isLoading || data?.ccrcCommunitiesCount === 0 || data?.rentalCommunitiesCount === 0) {
    return null;
  }

  const handleCommunityTypeChange = (event: RadioChangeEvent) => {
    if (event?.target?.value !== undefined) {
      setCommunityContractType?.(event.target.value);
    }
  };

  return (
    <CommunityTypesContainer>
      <CommunityTypesTitle>Apply to community types</CommunityTypesTitle>
      <Radio.Group onChange={handleCommunityTypeChange} value={communityContractType}>
        <StyledRadio value={VIEW_MODAL_ADD_COMMUNITY_TYPES.RENTAL}>Rental communities</StyledRadio>
        <StyledRadio value={VIEW_MODAL_ADD_COMMUNITY_TYPES.CCRC}>Life plan communities</StyledRadio>
        <StyledRadio value={VIEW_MODAL_ADD_COMMUNITY_TYPES.BOTH}>Both</StyledRadio>
      </Radio.Group>
    </CommunityTypesContainer>
  );
};

export default ViewInputModalCommunityRentalTypes;
